import appConstant from "../../../appConstants";
import { isShipmentsHasExcessiveLength } from "../../modules/Dispatch/utils/utils";

const DropdownValueCellRenderer = (params) => {
  return params.value && params.value.label !== undefined
    ? params.value.label
    : params.value;
};

const getMinutes = (str) => {
  if (str) {
    const time = str.split(":");
    return time[0] * 60 + Number(time[1]);
  }
  return 0;
};


const getTime = (str) => {
  return new Date(str).getTime();
}

const checkIfETAInDeliveryRange = (etaTime, maxWaitingTimeAtStop) => (deliverySlot) => {
  const eta = getTime(etaTime);
  const [startTime, endTime] = deliverySlot.split("-");
  const startTimeInMinutes = getTime(startTime);
  const endTimeInMinutes = getTime(endTime);
  const etaWithWaitingTime = eta + parseInt(maxWaitingTimeAtStop);
  if (startTimeInMinutes <= etaWithWaitingTime && eta <= endTimeInMinutes) {
    return appConstant.STOP_STATUS.ONTIME;
   } else if (startTimeInMinutes >= etaWithWaitingTime && eta <= endTimeInMinutes) {
     return appConstant.STOP_STATUS.EARLY_ARRIVAL;
   } else {
   return appConstant.STOP_STATUS.DELAYED;
  }
};

const StopStatusCellRenderer = (params) => {
  if (params.data.stopType === "AP") {
    return null;
  }
  let deliveryWindow = params.data.deliveryWindow || [];
  if (!Array.isArray(params.data.deliveryWindow)) {
    deliveryWindow = [deliveryWindow];
  }

  if (deliveryWindow.length !== 0) {
    const statusList = deliveryWindow.map(checkIfETAInDeliveryRange(params.data.eta, params.context.maxWaitingTimeAtStop))
    if(statusList.includes(appConstant.STOP_STATUS.DELAYED)){
     return appConstant.STOP_STATUS.DELAYED
    }else if(statusList.includes(appConstant.STOP_STATUS.EARLY_ARRIVAL)){
      return appConstant.STOP_STATUS.EARLY_ARRIVAL
    }else{
      return appConstant.STOP_STATUS.ONTIME;
    }
  }
  return null;
};

const DisabledButtonRenderer = (params) => {
  return <span className="disabledContent">Disabled</span>;
};

const SpecialNeedsValueGetter = (params) => {
  const {
    priority,
    liftgate,
    eqptPref,
    specialNeeds,
    specialInstruction,
    shipmentSpecialInstruction,
    eqpmtPref,
    apt,
    excessiveLength,
    isTrailerDrop,
    isDelivery,
    customerComments,
    shipperComments,
  } = params.data;
  const valuesArray = [apt, priority, liftgate];
  const equipmentPrefs = eqptPref || eqpmtPref;
  isTrailerDrop && valuesArray.push(appConstant.SpecialNeedsStrings.TrailerDrop);
  equipmentPrefs &&
    equipmentPrefs
      .split(", ")
      .map((equipmentPref) => valuesArray.push(equipmentPref));
  specialNeeds &&
    specialNeeds.split(",").map((specialNeed) => valuesArray.push(specialNeed));
  (specialInstruction || shipmentSpecialInstruction) && valuesArray.push("specialInstruction");
  (excessiveLength === appConstant.EXCESSIVE_SHIPMENT.YES && valuesArray.push(appConstant.SpecialNeedsStrings.ExcessiveLength))
  if (isDelivery && customerComments) { //shipment/customer/shipper grid
    valuesArray.push(appConstant.SpecialNeedsStrings.CC);
  }
  if (!isDelivery && shipperComments) { //shipment/customer/shipper grid
    valuesArray.push(appConstant.SpecialNeedsStrings.SC);
  }
  return valuesArray.filter((data) => data);
};


const isPickupStopUnAcknowledged = (stop) => {
  return stop.stopType === appConstant.STOP_TYPE.Pickup && !stop.isAcknowledged;
};
const totalUnAckPickupsValueGetter = (params) => {
  const { stops } = params.data;
  return stops.filter(isPickupStopUnAcknowledged).length;
};

const isDeliveryShipmentsHasSpecialInstructions = (stopData) => {
  return (
    stopData.shipments?.some((shipment) =>
      shipment.specialInstructions
    )
  );
};



const getSpecialNeeds = (params) => {
  const valuesArray = [];
  const {
    isApt,
    isFood,
    isPoison,
    isHazmat,
    isFreezable,
    isResidential,
    isLiftGate,
    isLimitedAccess,
    specialInstructions,
    priority,
    stopType,
    isExcessiveLength = false,
  } = params.data;
  let hasSpecialInstruction = specialInstructions;
  isApt && valuesArray.push(appConstant.SpecialNeedsStrings.APT);
  isFood && valuesArray.push(appConstant.SpecialNeedsStrings.FD);
  isPoison && valuesArray.push(appConstant.SpecialNeedsStrings.PZ);
  isHazmat && valuesArray.push(appConstant.SpecialNeedsStrings.HZ);
  isFreezable && valuesArray.push(appConstant.SpecialNeedsStrings.FZ);
  isResidential && valuesArray.push(appConstant.SpecialNeedsStrings.RES);
  isLimitedAccess && valuesArray.push(appConstant.SpecialNeedsStrings.LA);
  isLiftGate && valuesArray.push(appConstant.SpecialNeedsStrings.L);
  isExcessiveLength && valuesArray.push(appConstant.SpecialNeedsStrings.ExcessiveLength); //driverGrid renderer, driverInfoPopup for stopType Pickup
  priority?.length && valuesArray.push(...priority);
  if (stopType === appConstant.STOP_TYPE.Delivery && params.data.shipments?.length) {
    hasSpecialInstruction = isDeliveryShipmentsHasSpecialInstructions(params.data)
  }
  hasSpecialInstruction && valuesArray.push(appConstant.SpecialNeedsStrings.SI);
  if (!isExcessiveLength) { //pickup grid /stop renderer/driverInfoPopup for stopType Delivery
    const isExcessiveLength= isShipmentsHasExcessiveLength(params.data.shipments, stopType);
    isExcessiveLength && valuesArray.push(appConstant.SpecialNeedsStrings.ExcessiveLength);
  }
  return valuesArray;
};

const dispatchRoutesSpecialNeedsValueGetter = (params) => {
  const { stops } = params.data;
  let isApt,
    isFood,
    isPoison,
    isHazmat,
    isFreezable,
    isResidential,
    isLimitedAccess,
    isExcessiveLength;
  let priority = [];

  if (stops.length > 0) {
    stops.forEach((stop) => {
      isApt |= stop.isApt;
      isFood |= stop.isFood;
      isPoison |= stop.isPoison;
      isHazmat |= stop.isHazmat;
      isFreezable |= stop.isFreezable;
      isResidential |= stop.isResidential;
      isLimitedAccess |= stop.isLimitedAccess;
      priority = stop.priority?.length
        ? [...priority, ...stop.priority]
        : priority;
      isExcessiveLength |= isShipmentsHasExcessiveLength(stop.shipments, stop.stopType);
    });
  }

  let paramsObj = {
    data: {
      isApt,
      isFood,
      isPoison,
      isHazmat,
      isFreezable,
      isResidential,
      isLimitedAccess,
      isExcessiveLength,
      priority : [...new Set(priority)],
    },
  };

  return getSpecialNeeds(paramsObj);
};

export {
  DropdownValueCellRenderer,
  StopStatusCellRenderer,
  DisabledButtonRenderer,
  SpecialNeedsValueGetter,
  totalUnAckPickupsValueGetter,
  getSpecialNeeds,
  dispatchRoutesSpecialNeedsValueGetter,
};
